import { createContext, useContext, useReducer } from "react";
import type { PropsWithChildren } from "react";

import { api } from "~/utils/api";
import { filterReducer } from "../reducer";
import type { SlicesResultsFilterAction } from "../reducer";
import type { SlicesResultFilterSchema } from "../schema";

interface FilterContextType {
  filter: SlicesResultFilterSchema;
  dispatch: React.Dispatch<SlicesResultsFilterAction>;
  options: { name: string; value: string }[];
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const SlicesResultsFilterProvider: React.FC<
  PropsWithChildren & {
    researchId: string;
  }
> = ({ children, researchId }) => {
  const [options] = api.phase.getSlicesByResearchId.useSuspenseQuery({
    researchId,
  });

  const [filter, dispatch] = useReducer(filterReducer, {
    slice: options.at(-1)?.value,
  });

  return (
    <FilterContext.Provider value={{ filter, dispatch, options }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useSlicesResultsFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error(
      "useSlicesResultsFilterContext must be used within a FilterProvider",
    );
  }
  return context;
};
